/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RiepilogoTariffaDTO } from './riepilogo-tariffa-dto';
import { StatoTariffaCittadino } from './stato-tariffa-cittadino';
import { TariffarioMensaDTO } from './tariffario-mensa-dto';


export interface CittadinoTariffaMensaDTO { 
    stato?: StatoTariffaCittadino;
    riepilogo?: RiepilogoTariffaDTO;
    tariffario?: TariffarioMensaDTO;
}



